import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { Button, notification } from 'antd';
import React from 'react';

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    if (action.payload?.status === 400) {
      const message: string = action.payload.data.errors
        .map((error: any) => error.errorMessage)
        .join('<br/>');

      notification.error({
        message: 'Action Failed',
        description: React.createElement('div', {
          dangerouslySetInnerHTML: { __html: `<div>${message}</div>` },
        }),
      });
    } else if (action.payload?.status === 500) {
      notification.error({
        message: 'Unexpected Error',
        description: 'An unexpected error occurred. Please try again later.',
      });
    }
  }
  return next(action);
};
